<template>
    <div class="pa-4 d-flex justify-space-between" style="font-size: 26px">
        <div>{{ $props.title }}</div>
        <div>จำนวนรวม <b>{{ $props.price }}</b> {{ $props.type }}</div>
    </div>
</template>

<script>
    export default {
        name: "ReturnTitle",
        props: ['title', 'price', 'type'],
    }
</script>

<style scoped>

</style>
